import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../../i18n';
import { trackLanguageChanged } from '../../utils/analytics';

/**
 * Language picker styled to match the sidebar nav items: the current language's
 * flag sits in the icon slot (top) with its name as the label (bottom), exactly
 * like Home / Rules / Sign In. A transparent native <select> is overlaid so a
 * click opens the platform picker — whose option list is the only place the flag
 * is shown alongside the name. Native keeps it accessible and gives a platform
 * picker on mobile.
 */
export default function LanguageSwitcher({ className = '' }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const current = SUPPORTED_LANGUAGES.find((l) => l.code === i18n.language);

  return (
    <div className={`sidebar-lang ${className}`.trim()}>
      <span className="sidebar-nav-icon sidebar-lang-icon" aria-hidden="true">
        {current ? current.flag : <Globe size={20} />}
      </span>
      <span className="sidebar-nav-label">
        {current ? current.name : t('profile.language', 'Language')}
      </span>
      <select
        className="sidebar-lang-select"
        value={i18n.language}
        onChange={(e) => {
          const code = e.target.value;
          i18n.changeLanguage(code);
          trackLanguageChanged(code);
        }}
        aria-label={t('profile.language', 'Language')}
      >
        {SUPPORTED_LANGUAGES.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
}
